dataLayerHandler = {
    events: () => {
        const cardLinks = document.querySelectorAll(".card__link");
        cardLinks.forEach((cardLink) => {
            const card = cardLink.closest("product-info");
            const cardForm = card.querySelector("product-form");
            cardLink.addEventListener("click", (event) => {
                event.preventDefault();
                dataLayerHandler.itemClick(card, cardForm, () => {
                    if (document.body.classList.contains("template-search")) {
                        sendAnalyticsEventData(
                            USER_INTERACTION_ANALYTICS_EVENTS.searchResultClick,
                            {
                                index: card.dataset.analyticsIndex,
                                id: parseInt(card.dataset.analyticsProductId),
                            }
                        );
                    }
                    setTimeout(() => {
                        window.location.href = cardLink.href;
                    }, 1000);
                });
            });
        });
    },
    itemClick(card, cardForm, callback) {
        let productData = {
            title: card.dataset.analyticsProductTitle,
            price: card.dataset.analyticsProductPrice,
            category: card.dataset.analyticsCategory,
            format: card.dataset.analyticsFormat,
            flavour: card.dataset.analyticsFlavour,
            page_title: card.dataset.analyticsPageTitle,
            page_slug: card.dataset.analyticsPageSlug,
            type: card.dataset.analyticsProductType,
            handle: card.dataset.analyticsProductHandle,
            id: card.dataset.analyticsProductId,
            available: card.dataset.analyticsAvailable === "true",
            index: card.dataset.analyticsIndex
                ? card.dataset.analyticsIndex
                : 1,

            variant: cardForm
                ? cardForm.dataset.analyticsVariant
                : card.dataset.analyticsVariant,
            nicotine: cardForm
                ? cardForm.dataset.analyticsStrength
                : card.dataset.analyticsStrength,
            quantity: cardForm
                ? new FormData(cardForm.querySelector("form"))
                      .get("quantity")
                      .toString()
                : "1",
        };

        sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.selectItem, {
            ...productData,
        });

        callback();
    },
    callEvent(event = "", payload = {}, location = null) {
        if (!payload || !event) return;

        if (dataLayerDefaults.mode.length) {
            dataLayerDefaults.mode.forEach((mode) => {
                if (providers[mode] && providers[mode][event]) {
                    providers[mode][event](payload, location);
                } else {
                    if (location) {
                        setTimeout(() => {
                            window.location = location;
                        }, 1000);
                    }
                }
            });
        } else {
            if (location) window.location = location;
        }
    },
    pushEvent: (event, location = null) => {
        if (
            dataLayerDefaults.mode.length > 0 &&
            (typeof dataLayer !== "undefined" ||
                typeof adobeDataLayer !== "undefined")
        ) {
            if (
                typeof dataLayer !== "undefined" &&
                dataLayerDefaults.mode.includes("ga4")
            )
                dataLayer.push(event);
            if (
                typeof adobeDataLayer !== "undefined" &&
                dataLayerDefaults.mode.includes("adobe")
            )
                adobeDataLayer.push(event);

            if (dataLayerDefaults.debug)
                console.log("DV dataLayer - pushEvent", event);

            if (location) {
                if (dataLayerDefaults.debug) {
                    if (
                        window.confirm("DV dataLayer - Ready to move on?") ==
                        true
                    )
                        window.location = location;
                } else {
                    setTimeout(() => {
                        window.location = location;
                    }, 1000);
                }
            }
        } else {
            if (location) window.location = location;
        }
    },
    checkParams: () => {
        const url = new URL(window.location.href);
        const search = url.search;

        if (search === "" || !search) return;

        const searchParts = search.replace("?", "").split("&");
        let newSearchParts = [];

        searchParts.map((part) => {
            const key = part.split("=")[0];
            const value = part.split("=")[1];

            if (!dataLayerHandler.trackableParams(key, value))
                newSearchParts.push(key + "=" + value);
        });

        let newSearch = "";
        if (newSearchParts.length > 0)
            newSearch = "?" + newSearchParts.join("&");

        const fixedUrl = url.origin + url.pathname + newSearch;
        if (fixedUrl != window.location.href)
            history.pushState(null, document.title, fixedUrl);
    },

    trackableParams: (key, value) => {
        if (key == "age-verified" && value == "true") {
            addAnalyticsEvents(USER_INTERACTION_ANALYTICS_EVENTS.ageVerified);
            return true;
        }

        return false;
    },

    getCurrency: () => {
        return window.Shopify.currency.active || "EUR";
    },
};

dataLayerHandler.events();
dataLayerHandler.checkParams();

if (document.querySelectorAll(".errors").length) {
    dataLayerHandler.checkMessages();
}
if (dataLayerDefaults.debug) {
    console.log("DV dataLayer - Debug mode enabled");
}

if (dataLayerEvents && dataLayerEvents.length > 0) {
    dataLayerEvents.forEach(({ key, payload, location }) => {
        dataLayerHandler.pushEvent(
            { event: key, payload: payload ?? null },
            location ?? null
        );
    });
}

const providers = {
    ga4: {
        transformItem: (product = {}, hasCategory = true) => {
            let affiliation = "";
            if (window.store_affiliation)
                affiliation = window.store_affiliation;
            if (product.affiliation) affiliation = product.affiliation;

            let nicotineValue = "";
            if (product.nicotine) {
                nicotineValue = product.nicotine;
            } else if (product.options_with_values) {
                const nicotineObject = product.options_with_values.find(
                    (option) =>
                        ["strength", "nicotine level"].includes(
                            option.name.toLowerCase()
                        )
                );
                if (nicotineObject) nicotineValue = nicotineObject.value;
            }

            let item = {
                item_name: product.title,
                item_id: product.id ? product.id.toString() : "",
                price: product.price
                    ? (
                          formatMoney(product.price, "{{amount}}") ||
                          product.final_price
                      ).toString()
                    : "0",
                item_category:
                    product.category || product.analyticsCategory || "",
                item_brand: product.brand || dataLayerDefaults.brand,
                item_variant: product.variant || product.variant_title || "",
                index: product.index ? product.index : 1,
                quantity: product.quantity ? product.quantity.toString() : "1",
                affiliation: affiliation,
            };

            if (hasCategory) {
                item = {
                    ...item,
                    item_category_2:
                        product.format || product.analyticsFormat || "",
                    item_category_3:
                        product.flavour || product.analyticsFlavour || "",
                    item_category_4: nicotineValue,
                    item_list_name:
                        product.page_title || dataLayerDefaults.page_title,
                };
            }

            if (product.voucher_code) item.item_coupon = product.voucher_code;
            if (product.discount && product.discount > 0)
                item.discount = product.discount.toString();

            return item;
        },
        subscriptionItem: (product = {}) => {
            if (product.options_with_values) {
                var productOptions = product.options_with_values;

                var nicotineObject = productOptions.find((productOption) => {
                    var nameDowncase = productOption.name.toLowerCase();

                    if (
                        nameDowncase === "strength" ||
                        nameDowncase === "nicotine level"
                    )
                        return true;
                });
            }

            let nicotineValue = "";
            if (product.nicotine) {
                nicotineValue = product.nicotine;
            } else if (nicotineObject) {
                nicotineValue = nicotineObject.value;
            }

            let productObject = {
                subscribedProduct: product.title,
                subscribedProductId: product.id.toString(),
                subscribedItemsPrice: product.price
                    ? (
                          formatMoney(product.price, "{{amount}}") ||
                          product.final_price
                      ).toString()
                    : "0",
                subscribedItemPosition: product.index ?? 1,
                subscribedItemsVariant:
                    product.variant || product.variant_title || "",
                format: product.format ?? "",
                flavour: product.flavour ?? "",
                strength: nicotineValue ?? "",
                systemType: product.systemType ?? "Closed",
            };

            return productObject;
        },
    },
    adobe: {
        transformItem: (product = {}) => {
            let price = parseInt(
                formatMoney(product.price, "{{amount_no_decimals}}")
            );

            let qty = "1";
            if (product.quantity) {
                if (typeof product.quantity === "number")
                    qty = product.quantity.toString();
                else qty = product.quantity;
            }

            let product_id = product.id;
            if (typeof product_id === "string")
                product_id = parseInt(product.id);

            let tax = 0;
            if (price > 0 && dataLayerDefaults.taxMultiplier > 0) {
                tax = parseFloat(
                    parseFloat(price * dataLayerDefaults.taxMultiplier).toFixed(
                        2
                    )
                );
            }
            if (product.options_with_values) {
                var productOptions = product.options_with_values;

                var nicotineObject = productOptions.find((productOption) => {
                    var nameDowncase = productOption.name.toLowerCase();

                    if (
                        nameDowncase === "strength" ||
                        nameDowncase === "nicotine level"
                    )
                        return true;
                });
            }

            let nicotineValue = "";
            if (product.nicotine) {
                nicotineValue = product.nicotine;
            } else if (nicotineObject) {
                nicotineValue = nicotineObject.value;
            }
            return {
                name: product.title,
                category: product.category || product.analyticsCategory || "",
                categoryTree:
                    product.page_title || dataLayerDefaults.page_title,
                nicotine: nicotineValue || product.nicotine || "",
                color: product.colour || "",
                saveur: product.flavour || product.analyticsFlavour || "",
                assetID: parseInt(product.id),
                abonnement:
                    product.subscription ||
                    (product.properties?._subscription === "true"
                        ? "yes"
                        : "no"),
                subscription: product.subscription || "no",
                brand: product.brand || dataLayerDefaults.brand,
                type: "",
                id: parseInt(product.id),
                code: "",
                status: "",
                quantity: qty,
                price: price,
                discountPrice: product.discountPrice || price,
                basePrice: product.basePrice || price,
                tax: tax,
                varient: product.variant_title || product.variant || "",
                totalPrice: price,
                imageURL: product.imageURL || "",
                bundleType: "",
                groupName: product.page_title || dataLayerDefaults.page_title,
            };
        },

        subscriptionItem: (product = {}) => {
            let price = product.price;
            if (typeof price === "string")
                price = parseFloat(product.price.replace(",", "."));
            if (typeof price === "number") price = price.toString();

            let discountPrice = product.discountPerItem;
            if (typeof discountPrice === "number")
                discountPrice = product.discountPerItem.toString();

            let product_id = product.id;
            if (typeof product_id === "number")
                product_id = product.id.toString();
            product_id = product_id.replace(
                "gid://shopify/ProductVariant/",
                ""
            );

            let qty = "1";
            if (product.qty) {
                if (typeof product.qty === "string") qty = parseInt();
                else qty = product.qty;
            }

            let tax = "0";
            if (price > 0 && dataLayerDefaults.taxMultiplier > 0) {
                tax = parseFloat(
                    parseFloat(price * dataLayerDefaults.taxMultiplier).toFixed(
                        2
                    )
                );
                tax = tax.toString();
            }

            const page = product.page_title || dataLayerDefaults.page_title;

            return {
                name: product.title,
                category: product.category || "",
                categoryTree: [page],
                device: "",
                deviceSCategory: "",
                nicotine: product.nicotine || "",
                colour: product.colour || "",
                saveur: product.flavour || "",
                assetID: product_id,
                abonnement: product.discountLabel || "",
                subscription: "yes",
                type: "",
                id: product_id,
                code: product_id,
                status: product_id,
                price: price,
                discountPrice: discountPrice,
                basePrice: price,
                tax: tax,
                quantity: qty,
                routeToCart: "",
                variant: product.variant || "",
                imageURL: product.imageUrl || "",
                BundleType: "",
                GroupName: page,
            };
        },
    },
};

/**
 * GA4 Subscribe Events
 */

addAnalyticsEvents(USER_INTERACTION_ANALYTICS_EVENTS.viewItem, (product) => {
    const transformedItem = providers.ga4.transformItem(product);
    dataLayerHandler.pushEvent({
        event: "view_item",
        ecommerce: {
            items: [transformedItem],
        },
    });
});

addAnalyticsEvents(
    USER_INTERACTION_ANALYTICS_EVENTS.selectItem,
    (payload = {}, location = null) => {
        console.log("select item called!");
        dataLayerHandler.pushEvent(
            {
                event: "select_item",
                ecommerce: {
                    items: [providers.ga4.transformItem(payload)],
                },
            },
            location
        );
    }
);

addAnalyticsEvents(
    USER_INTERACTION_ANALYTICS_EVENTS.viewItemList,
    (payload) => {
        var items = [];
        payload.products.map((product) =>
            items.push(providers.ga4.transformItem(product))
        );

        dataLayerHandler.pushEvent({
            event: "view_item_list",
            ecommerce: {
                items: items,
            },
        });
    }
);

addAnalyticsEvents(USER_INTERACTION_ANALYTICS_EVENTS.search, (payload) => {
    dataLayerHandler.pushEvent({
        event:
            payload.results_count > 0
                ? USER_INTERACTION_ANALYTICS_EVENTS.search
                : "unsuccesfulsearch",
        SearchTerm: payload.term || "",
        SearchResults: payload.results_count || 0,
        UserID: payload.customer_id || "",
        pageType: "searchResults",
    });
});

addAnalyticsEvents(USER_INTERACTION_ANALYTICS_EVENTS.pageView, (payload) => {
    let loggedInParams = {};

    if (payload.user) {
        loggedInParams = {
            favouriteProduct: "",
            usualproduct: "",
            previousorders: payload.user.previousorders,
            previousorderedProducts: payload.user.previousorderedProducts,
            Subscription: "",
            subscribedProduct: "",
            subscribtionFrequency: "",
            subscribedItems: "",
            subscribedItemsPrice: "",
            emailsubscription: payload.user.emailsubscription,
            emailsubscriptionItem: payload.user.emailsubscriptionItem,
            ActivePaymentMethods: "",
            NumberOfActivePaymentMethods: "",
        };
    }

    const event = {
        event: payload.user ? "all_pages_login" : "all_pages",
        UserID:
            payload.user && payload.user.customer_id
                ? payload.user.customer_id
                : "",
        PageType: payload.page_type || "",
        SiteSection: payload.page_type || "",
        SystemType: payload.system_type || "",
        LoggedInStatus:
            payload.user && payload.user.customer_id
                ? "logged in"
                : "logged out",
        Country: window.Shopify.country,
        ServerSideTimestamp: new Date(),
        ...loggedInParams,
    };

    dataLayerHandler.pushEvent(event);
});

addAnalyticsEvents(USER_INTERACTION_ANALYTICS_EVENTS.login, (payload) => {
    let loggedInParams = {};

    if (payload.failed) {
        loggedInParams = {
            eventType: payload.failed.reason || "",
            eventFields: payload.failed.fields || "",
        };
    }

    dataLayerHandler.pushEvent({
        event: "account",
        eventAction: "login",
        eventLabel: payload.failed ? "fail" : "success",
        ...loggedInParams,
    });
});

addAnalyticsEvents(
    USER_INTERACTION_ANALYTICS_EVENTS.registration,
    (payload) => {
        let registrationParams = {};

        if (payload.failed) {
            registrationParams = {
                eventType: payload.failed.reason || "",
                eventFields: payload.failed.fields || "",
            };
        }

        dataLayerHandler.pushEvent({
            event: "registration",
            eventAction: "registration Success",
            eventLabel: payload.failed ? "fail" : "success",
            ...registrationParams,
        });
    }
);

addAnalyticsEvents(
    USER_INTERACTION_ANALYTICS_EVENTS.cart,
    (payload = {}, location = null) => {
        let items = [];

        if (payload.products) {
            payload.products.map((product) => {
                const augmentedProduct = {
                    ...product,
                    ...payload.additionalData,
                    quantity: product.quantity.toString(),
                };
                items.push(providers.ga4.transformItem(augmentedProduct));
            });
        }

        if (items.length > 0) {
            dataLayerHandler.pushEvent(
                {
                    event: payload.event ?? "add_to_cart",
                    ecommerce: {
                        items: items,
                    },
                },
                location
            );

            if (payload.event == "add_to_cart") {
                let subsItems = [];

                payload.products.map((item) => {
                    if (item.properties?._subscription === "true") {
                        for (
                            var i = 0;
                            i <
                            parseInt(
                                payload.additionalData.productVariantQuantity
                            );
                            i++
                        )
                            subsItems.push({
                                ...item,
                                format: payload.additionalData.format,
                                flavour: payload.additionalData.flavour,
                                category: payload.additionalData.category,
                            });
                    }
                });

                if (subsItems.length > 0) {
                    addAnalyticsEvents(
                        USER_INTERACTION_ANALYTICS_EVENTS.subscribeAction,
                        {
                            event: "subscriptionAddToCart",
                            products: subsItems,
                        }
                    );
                }
            }
        }
    }
);

addAnalyticsEvents(
    USER_INTERACTION_ANALYTICS_EVENTS.repeatPurchase,
    (payload = {}) => {
        dataLayerHandler.pushEvent({
            event: USER_INTERACTION_ANALYTICS_EVENTS.repeatPurchase,
            eventAction: payload.action ?? "Shown",
            eventLabel: "Repeat Purchase",
            eventCategory: payload.context ?? "Popup",
        });
    }
);

addAnalyticsEvents(
    USER_INTERACTION_ANALYTICS_EVENTS.storeLocator,
    (payload = {}) => {
        let storeClickParams = {};

        if (payload.click) {
            storeClickParams = {
                getDirections: "yes",
                distance: payload.click.distance || "",
            };
        }

        dataLayerHandler.pushEvent({
            eventName: payload.cl
                ? "StoreLocatorUseLocation"
                : "StoreLocatorSearch",
            searchedstore: payload.term ?? "no store found",
            storeSearchResults: payload.results ?? 0,
            ...storeClickParams,
        });
    }
);

addAnalyticsEvents(USER_INTERACTION_ANALYTICS_EVENTS.logout, (payload) => {
    dataLayerHandler.pushEvent({
        event: "account",
        eventAction: "logout",
        eventLabel: "success",
    });
});

addAnalyticsEvents(
    USER_INTERACTION_ANALYTICS_EVENTS.subscribeToggle,
    (payload) => {
        const subscriptionItem = providers.ga4.subscriptionItem(payload);
        const isProductPage =
            document.body.classList.contains("template-product");
        dataLayerHandler.pushEvent({
            event: isProductPage
                ? "Subscribe Option Selected"
                : "Subscribe From",
            "gtm.uniqueEventId": isProductPage ? 17 : 18,
            product: subscriptionItem,
        });
    }
);

addAnalyticsEvents(
    USER_INTERACTION_ANALYTICS_EVENTS.subscribeAction,
    (payload) => {
        let products = [];
        payload.products.map((product) => {
            products.push(providers.ga4.subscriptionItem(product));
        });
        dataLayerHandler.pushEvent({
            event:
                payload.event ??
                USER_INTERACTION_ANALYTICS_EVENTS.subscribeAction,
            subscribedItems: products,
        });
    }
);

addAnalyticsEvents(
    USER_INTERACTION_ANALYTICS_EVENTS.beginCheckout,
    (payload) => {
        var items = [];

        payload.products.map((product) =>
            items.push(providers.ga4.transformItem(product))
        );

        dataLayerHandler.pushEvent({
            event: "begin_checkout",
            ecommerce: {
                items: items,
            },
        });
    }
);

addAnalyticsEvents(USER_INTERACTION_ANALYTICS_EVENTS.newsletter, () => {
    dataLayerHandler.pushEvent({
        event: "newsletter",
        eventAction: "newsletter sign up",
        eventLabel: "success",
    });
});

/**
 * Adobe Subscribe Events
 */

addAnalyticsEvents(USER_INTERACTION_ANALYTICS_EVENTS.viewItem, (payload) => {
    dataLayerHandler.pushEvent({
        event: "productView",
        ecommerce: {
            basketId: parseInt(payload.basketId) || 0,
            currency: dataLayerHandler.getCurrency(),
            view: {
                product: [providers.adobe.transformItem(payload)],
            },
        },
    });
});

addAnalyticsEvents(
    USER_INTERACTION_ANALYTICS_EVENTS.cartView,
    (payload = {}, location = null) => {
        addAnalyticsEvents(USER_INTERACTION_ANALYTICS_EVENTS.cart, {
            event: "cart_view",
            ...payload,
        });
    }
);
addAnalyticsEvents(USER_INTERACTION_ANALYTICS_EVENTS.login, (payload) => {
    if (payload.failed) {
        return;
    }

    dataLayerHandler.pushEvent({
        event: "login_success",
        form: "lLogingin",
        formType: "Login",
        eventTrigger: "Header",
    });
});

addAnalyticsEvents(USER_INTERACTION_ANALYTICS_EVENTS.pageView, (payload) => {
    let view = {
        event: "pageView",
        user: {
            mcid: "",
            gender: "",
            gdpr: 1,
            prefecture: "",
            registeredProduct: "",
            loginStarted: "No",
            loginStatus: "guest",
            loginMethod: "",
            brand: "",
            salesforceID: "",
            tonicID: "",
            type: "",
            email: "",
            yearOfBirth: "",
            gloId: "",
            consent: "",
            newsletter: "",
        },
    };

    if (payload.user) {
        const userPayload = view.user;
        view.user = {
            ...userPayload,
            loginStarted: "Yes",
            loginStatus: "Logged In",
            loginMethod: "Website",
            brand: dataLayerDefaults.brand,
            salesforceID: 0,
            tonicID: 0,
            type: payload.user.previousorders > 0 ? "Existing" : "New",
            yearOfBirth: payload.user.yearOfBirth,
            gloId: 0,
            consent: 1,
            newsletter: payload.user.emailsubscription == "yes" ? "email" : "",
        };
    }

    if (payload.page) {
        const pageLoad =
            window.performance.timing.domContentLoadedEventEnd -
            window.performance.timing.navigationStart;

        let languageNames = new Intl.DisplayNames(["en"], { type: "language" });

        view.page = {
            category: payload.page.category,
            templateType: payload.page.templateType,
            templateName: payload.page.templateName,
            type: payload.page.type,
            update: payload.page.update,
            url: payload.page.url,
            tags: payload.page.tags,
            country: window.Shopify.country,
            language: languageNames.of(Shopify.locale),
            domain: payload.page.domain,
            path: payload.page.path,
            loadTime: pageLoad,
            scroll_percent: "",
            previousPageName: payload.page.previousPageName,
            name: payload.page.name,
            campaign: "",
            internalCampaign: "",
            timestamp: new Date().getTime(),
        };
    }

    if (payload.cart) {
        let products = [];
        if (payload.cart.products && payload.cart.products.length > 0) {
            payload.cart.products.map((item) => {
                products.push(providers.adobe.transformItem(item));
            });
        }

        view.cart = {
            basketId: payload.cart.basketId | "",
            product: products,
        };
    }

    dataLayerHandler.pushEvent(view);
});

addAnalyticsEvents(
    USER_INTERACTION_ANALYTICS_EVENTS.registration,
    (payload) => {
        let registrationParams = {};

        if (payload.failed) {
            registrationParams = {
                formError: payload.failed.reason || "",
            };
        }

        dataLayerHandler.pushEvent({
            event: payload.failed ? "register_start" : "register_success",
            form: "Registration",
            formType: "Registration",
            ...registrationParams,
            eventTrigger: "Header",
        });
    }
);

addAnalyticsEvents(USER_INTERACTION_ANALYTICS_EVENTS.search, (payload) => {
    dataLayerHandler.pushEvent({
        event: "search",
        form: "search",
        formType: "search",
        resultCount: payload.results_count || 0,
        searchCriteria: payload.term || "",
    });
});

addAnalyticsEvents(
    USER_INTERACTION_ANALYTICS_EVENTS.searchResultClick,
    (payload) => {
        dataLayerHandler.pushEvent({
            event: USER_INTERACTION_ANALYTICS_EVENTS.searchResultClick,
            resultClickType: "product",
            resultClickPosition: payload.index,
            resultProductId: payload.id,
        });
    }
);

addAnalyticsEvents(USER_INTERACTION_ANALYTICS_EVENTS.filter, (payload) => {
    dataLayerHandler.pushEvent({
        event: "Filters",
        "Filter results": payload.count,
        FilterName: payload.title,
    });
});

addAnalyticsEvents(USER_INTERACTION_ANALYTICS_EVENTS.ageVerified, (payload) => {
    dataLayerHandler.pushEvent({
        event: "Age Verification",
        eventAction: "success",
    });
});

addAnalyticsEvents(
    USER_INTERACTION_ANALYTICS_EVENTS.checkoutAddress,
    (payload) => {
        dataLayerHandler.pushEvent({
            event: USER_INTERACTION_ANALYTICS_EVENTS.checkoutAddress,
            ecommerce: {
                address: {
                    city: payload.city,
                    zipcode: payload.postcode,
                    region: payload.county,
                },
            },
        });
    }
);

addAnalyticsEvents(
    USER_INTERACTION_ANALYTICS_EVENTS.checkoutAddress,
    (payload) => {
        let items = [];

        if (payload.products)
            payload.products.map((product) =>
                items.push(providers.adobe.subscriptionItem(product))
            );

        let eventKey = "Subscription";
        if (payload.key) eventKey = payload.key;

        let basketId = "";
        if (payload.basketId) basketId = payload.basketId + "";

        let orderId = "";
        if (payload.orderId)
            orderId = (payload.orderId + "").replace(
                "gid://shopify/Order/",
                ""
            );

        let subscriptionId = "";
        if (payload.subscriptionId)
            subscriptionId = (payload.subscriptionId + "").replace(
                "gid://shopify/Order/",
                ""
            );

        dataLayerHandler.pushEvent({
            event: eventKey,
            reason: payload.reason || "",
            ecommerce: {
                currency: dataLayerHandler.getCurrency(),
                basketId: basketId,
                order: {
                    orderID: orderId,
                    subscritionID: subscriptionId,
                    orderdate: payload.orderDate || "",
                    orderstatus: "",
                    shippingCost: payload.shippingCost + "" || "0",
                    TotalOrderValue: payload.TotalOrderValue + "" || "0",
                    paymentmethod: "credit card",
                    ShipmentRequestingDate: "",
                    ShipmentRequestingTime: "",
                    BundleType: "",
                    subscription: "",
                    coupon: payload.coupon || "",
                    totalTax: payload.totalTax + "" || "0",
                    deliveryPrice: payload.shippingCost + "" || "0",
                    totalBasePrice: payload.TotalOrderValue + "" || "0",
                    totaldiscountPrice:
                        parseFloat(payload.totalDiscount).toFixed(2) + "" ||
                        "0",
                    product: items,
                },
            },
        });
    }
);

addAnalyticsEvents(
    USER_INTERACTION_ANALYTICS_EVENTS.cart,
    (payload = {}, location = null) => {
        let items = [];

        if (payload.products) {
            payload.products.map((product) => {
                const augmentedProduct = {
                    ...product,
                    ...payload.additionalData,
                };
                items.push(providers.adobe.transformItem(augmentedProduct));
            });
        }

        let eventKey = "addToCart";
        if (payload.event === "remove_from_cart") eventKey = "removeFromCart";
        if (payload.event === "cart_view") eventKey = "cartView";

        let key = "add";
        if (payload.event === "remove_from_cart") key = "remove";
        if (payload.event === "cart_view") key = "cart";

        dataLayerHandler.pushEvent(
            {
                event: eventKey,
                ecommerce: {
                    currencyCode: dataLayerHandler.getCurrency(),
                    basketId: parseInt(payload.basketId) || 0,
                    [key]: {
                        product: items,
                    },
                },
            },
            location
        );
    }
);

addAnalyticsEvents(
    USER_INTERACTION_ANALYTICS_EVENTS.beginCheckout,
    (payload) => {
        let items = [];

        if (payload.products)
            payload.products.map((product) =>
                items.push(providers.adobe.transformItem(product))
            );

        if (items.length > 0) {
            dataLayerHandler.pushEvent({
                event: "checkout",
                ecommerce: {
                    currencyCode: dataLayerHandler.getCurrency(),
                    basketId: parseInt(payload.basketId) || 0,
                    checkout: {
                        product: items,
                    },
                },
            });
        }
    }
);

addAnalyticsEvents(
    USER_INTERACTION_ANALYTICS_EVENTS.updateSubscription,
    (payload) => {
        let items = [];

        if (payload.products)
            payload.products.map((product) =>
                items.push(providers.adobe.subscriptionItem(product))
            );

        let eventKey = "Subscription";
        if (payload.key) eventKey = payload.key;

        let basketId = "";
        if (payload.basketId) basketId = payload.basketId + "";

        let orderId = "";
        if (payload.orderId)
            orderId = (payload.orderId + "").replace(
                "gid://shopify/Order/",
                ""
            );

        let subscriptionId = "";
        if (payload.subscriptionId)
            subscriptionId = (payload.subscriptionId + "").replace(
                "gid://shopify/Order/",
                ""
            );

        dataLayerHandler.pushEvent({
            event: eventKey,
            reason: payload.reason || "",
            ecommerce: {
                currency: dataLayerHandler.getCurrency(),
                basketId: basketId,
                order: {
                    orderID: orderId,
                    subscritionID: subscriptionId,
                    orderdate: payload.orderDate || "",
                    orderstatus: "",
                    shippingCost: payload.shippingCost + "" || "0",
                    TotalOrderValue: payload.TotalOrderValue + "" || "0",
                    paymentmethod: "credit card",
                    ShipmentRequestingDate: "",
                    ShipmentRequestingTime: "",
                    BundleType: "",
                    subscription: "",
                    coupon: payload.coupon || "",
                    totalTax: payload.totalTax + "" || "0",
                    deliveryPrice: payload.shippingCost + "" || "0",
                    totalBasePrice: payload.TotalOrderValue + "" || "0",
                    totaldiscountPrice:
                        parseFloat(payload.totalDiscount).toFixed(2) + "" ||
                        "0",
                    product: items,
                },
            },
        });
    }
);

addAnalyticsEvents(
    USER_INTERACTION_ANALYTICS_EVENTS.checkoutAddress,
    (payload) => {
        dataLayerHandler.pushEvent({
            event: "checkout_address",
            ecommerce: {
                address: {
                    city: payload.city,
                    zipcode: payload.postcode,
                    region: payload.county,
                },
            },
        });
    }
);

addAnalyticsEvents(USER_INTERACTION_ANALYTICS_EVENTS.newsletter, () => {
    dataLayerHandler.pushEvent({
        event: "newsletter_complete",
        form: "newsletter",
        formType: "newsletter",
        eventTrigger: "Header",
    });
});

addAnalyticsEvents(USER_INTERACTION_ANALYTICS_EVENTS.purchase, (payload) => {
    var items = [];
    payload.products.map((product) =>
        items.push(providers.ga4.transformItem(product))
    );

    dataLayerHandler.pushEvent({
        event: "purchase",
        ecommerce: {
            transaction_id: payload.transaction_id || "",
            value: (payload.value || 0).toString(),
            tax: (payload.tax || 0).toString(),
            shipping: (payload.shipping || 0).toString(),
            currency: payload.currency || dataLayerHandler.getCurrency(),
            coupon: payload.coupon || "",
            purchase_type: payload.purchase_type || "",
            items: items,
        },
    });
});

addAnalyticsEvents(
    USER_INTERACTION_ANALYTICS_EVENTS.freeTrialQuiz,
    (payload) => {
        dataLayerHandler.pushEvent({
            event: "free_trial_quiz",
            results: payload,
        });
    }
);

addAnalyticsEvents(USER_INTERACTION_ANALYTICS_EVENTS.freeTrial, (payload) => {
    dataLayerHandler.pushEvent({
        event: "free_trial_purchase",
        affiliation: "Online Store",
        coupon: payload.coupon,
        transaction_id: "",
        revenue: "0.00",
        shipping: "0.0",
        tax: "0.00",
        brand: payload.brand,
        category: payload.category,
        product_id: payload.product_id,
        name: payload.name,
        price: "0.00",
        quantity: "1",
        // VELO GB SPECIFIC
        action: "purchase",
        dimension10: payload.bi_format,
        dimension12: payload.bi_flavour,
        dimension13: "",
        dimension16: payload.bi_nicotine,
        variant: payload.variant_title,
        // VELO FR SPECIFIC
        PurchaseType: "Free Trial",
        NicotineStrength: payload.bi_nicotine,
    });
});
